{
  "version": 1,
  "cost_centers": {
    "hr": { "fa": "منابع انسانی", "en": "Human resources" },
    "procurement": { "fa": "تأمین و خرید", "en": "Procurement" },
    "equipment": { "fa": "تجهیزات", "en": "Equipment" },
    "admin": { "fa": "اداری", "en": "Administration" },
    "marketing": { "fa": "بازاریابی", "en": "Marketing" },
    "medical_services": { "fa": "خدمات پزشکی", "en": "Medical services" }
  },
  "origins": {
    "expenses": ["manual", "recurring"],
    "people": ["payroll"],
    "inventory": ["purchase", "supplier_return"],
    "equipment": ["purchase", "install", "service", "calibration", "repair", "depreciation"],
    "clinic": [
      "bill.electricity",
      "bill.water",
      "bill.gas",
      "bill.landline",
      "bill.mobile",
      "bill.internet",
      "bill.municipality",
      "bill.tax",
      "bill.insurance_premium",
      "bill.rent",
      "bill.service_charge",
      "bill.other"
    ],
    "marketing": ["campaign"],
    "medical_services": ["consumption", "side_cost"]
  },
  "rules": [
    { "origin": "people.payroll", "cost_center": "hr" },
    { "origin": "inventory.purchase", "cost_center": "procurement" },
    { "origin": "inventory.supplier_return", "cost_center": "procurement" },
    { "origin": "equipment.*", "cost_center": "equipment" },
    { "origin": "clinic.bill.*", "cost_center": "admin" },
    { "origin": "marketing.campaign", "cost_center": "marketing" },
    { "origin": "medical_services.*", "cost_center": "medical_services" },
    { "origin": "expenses.*", "category": "personnel", "cost_center": "hr" },
    { "origin": "expenses.*", "category": "operating", "cost_center": "admin" },
    { "origin": "expenses.*", "category": "equipment", "cost_center": "equipment" },
    { "origin": "expenses.*", "category": "consumable", "cost_center": "procurement" },
    { "origin": "expenses.*", "category": "depreciation", "cost_center": "equipment" },
    { "origin": "expenses.*", "category": "marketing", "cost_center": "marketing" },
    { "origin": "expenses.*", "category": "other", "cost_center": "admin" }
  ]
}
